const swiper = new Swiper('.featured-slider', {
	effect: 'cards',
	cardsEffect: {
		slideShadows: false,
	},
	grabCursor: true,
	touchRatio: 0.3,
	navigation: {
		nextEl: '.featured-slider-button-next',
		prevEl: '.featured-slider-button-prev',
	},
});
